const Hero = () => {
  return (
    <div className="text-center flex flex-col items-center justify-center gap-2 lg:gap-4">
      <span className="text-3xl font-bold lg:text-5xl">
        Déjà des milliers d'avis certifiés
      </span>
      <span className="text-3xl font-bold text-primary lg:text-5xl">
        partagez le vôtre !
      </span>
    </div>
  );
};

export default Hero;
